module.exports = __webpack_public_path__ + "img/38-config-usuario-grupos-lista.c002e222.png";